/**
 * Shared Cypher fragments for DCS tree vs detail lists.
 *
 * Sequence FBs (`STEP` / `TRANSITION` / `HANDLER`) stay off the rail even
 * when `block_role` is missing (older ingest) or was stamped `logic`
 * because Honeywell ClassName did not match CompType T/H.
 */

export const DCS_SEQUENCE_BLOCK_TYPES_CYPHER = `['STEP', 'TRANSITION', 'HANDLER']`

export function dcsLogicFbPredicate(alias: string): string {
  return (
    `coalesce(${alias}.block_role, 'logic') = 'logic'` +
    ` AND NOT toUpper(coalesce(${alias}.block_type, '')) IN ${DCS_SEQUENCE_BLOCK_TYPES_CYPHER}`
  )
}

export function dcsSequenceFbPredicate(alias: string): string {
  return (
    `(${alias}.block_role IN ['step', 'transition', 'handler']` +
    ` OR toUpper(coalesce(${alias}.block_type, '')) IN ${DCS_SEQUENCE_BLOCK_TYPES_CYPHER})`
  )
}
